import {
  GET_ACCOUNT_MANAGEMENT,
  GET_ACCOUNT_MANAGEMENT_ALL,
  GET_ACCOUNT_MANAGEMENT_BLOCK_ERROR,
  GET_ACCOUNT_MANAGEMENT_CREATE_ERROR,
  GET_ACCOUNT_MANAGEMENT_EDIT_ERROR,
  GET_ACCOUNT_MANAGEMENT_UNBLOCK_ERROR,
  GET_ACCOUNT_MANAGEMENT_UPDATE_ERROR,
  GET_AVAILABLE_ROLES,
  UPDATE_SELECTS_DEPENDING_DEPARTMENT,
} from "../types";

const initialState = {
  accountManagementsAll: [],
  accountManagement: {},
  editError: false,
  createError: false,
  updateError: false,
  blockError: false,
  unblockError: false,
  textError: "",
  availableRoles: [],
  userPositionOptins: [],
  sectionOptions: [],
};

export const accountManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SELECTS_DEPENDING_DEPARTMENT:
      return {
        ...state,
        userPositionOptins: action.data.dataPositionWithId,
        sectionOptions: action.data.dataSectionWithId,
      };
    case GET_ACCOUNT_MANAGEMENT_ALL:
      return (() => ({
        ...state,
        accountManagementsAll: action.data,
      }))();
    case GET_ACCOUNT_MANAGEMENT:
      return (() => ({
        ...state,
        accountManagement: action.data,
      }))();
    case GET_ACCOUNT_MANAGEMENT_EDIT_ERROR:
      return (() => ({
        ...state,
        editError: action.data.errorStatus,
        textError: action.data.errorText,
      }))();
    case GET_ACCOUNT_MANAGEMENT_CREATE_ERROR:
      return (() => ({
        ...state,
        createError: action.data.errorStatus,
        textError: action.data.errorText,
      }))();
    case GET_ACCOUNT_MANAGEMENT_UPDATE_ERROR:
      return (() => ({
        ...state,
        updateError: action.data.errorStatus,
        textError: action.data.errorText,
      }))();
    case GET_ACCOUNT_MANAGEMENT_BLOCK_ERROR:
      return (() => ({
        ...state,
        blockError: action.data.errorStatus,
        textError: action.data.errorText,
      }))();
    case GET_ACCOUNT_MANAGEMENT_UNBLOCK_ERROR:
      return (() => ({
        ...state,
        unblockError: action.data.errorStatus,
        textError: action.data.errorText,
      }))();
    case GET_AVAILABLE_ROLES:
      return (() => ({
        ...state,
        availableRoles: action.data,
      }))();
    default:
      return state;
  }
};
